/**
 * Payment terms.
 *
 * Net 30 — the firm's engagement letters say "due and payable within thirty
 * (30) days of invoice date", and a matter with no engagement letter gets the
 * same treatment.
 *
 * Not read from the engagement: `ingest/engagement-letter.ts` doesn't extract
 * the payment-terms clause and `engagements` has no column for it, so every
 * invoice uses this. If a matter ever needs different terms, that field is
 * where they would come from — the due date stays editable by hand meanwhile.
 */
export const NET_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * The due date for an issue date, or null when there is no issue date to
 * count from.
 *
 * Plain millisecond arithmetic, matching how every other date in the app is
 * held (epoch ms, midnight-local). Across a DST boundary this lands on the
 * same wall-clock hour ±1h, which cannot change the calendar day for the
 * midnight-local values `<DateInput>` produces.
 */
export function dueDateFor(issueDate: number | null, netDays: number = NET_DAYS): number | null {
  return issueDate === null ? null : issueDate + netDays * DAY_MS;
}
